import apiUrl from '../../../constants'
import axios from 'axios'
import VueElementLoading from 'vue-element-loading';
import CryptoJS from 'crypto-js';
import moment from 'moment'
import download from 'downloadjs';
import Multiselect from 'vue-multiselect'

export default {
  name: 'awb-verification',
  components: {
    VueElementLoading,
    download,
    Multiselect
  },
  props: [],
  data() {
    return {
      isLoading: false,
      type: '',
      AWBnumber: '',
      measurementmethod: 'Manual',
      MPSnumber: '',
      dimensionUOM: 'Centimeter',
      length: '',
      breadth: '',
      height: '',
      weight: '',
      FltMPSnumber: '',
      FltIsMeasurement: false,
      AWB: '',
      AWBStatus: '',
      ScannedMPSList: [],
      MPSMeasuredCount:0,
      isLoadingSearch: false,
      createdby: '',
      userhubid: '',
      ScannedMPSListFLT:[],
      csvFields: [],
      csvData:[],
      noRecord:true,
      showAll:false,
      errorMessage:'',
      disableField:false,
      disableMPSField:false,
      CFT:'',
      ClientID:'',
      TruckloadType:'',
      RouteMode:'',
      BookingType:'',
      isverificationenabled:false,
      ClientBusinessAccountId:'',
      clientcontractid:'',
      isverificationenabledMsg:'',
      verificationHubName:'',
      emptyValueMsg:true
    }
  },
  computed: {},
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
    toFixedNum: function(val) {
      if (val && val > 0) {
        return Number(parseFloat(val).toFixed(2));
      } else {
        return 0;
      }
    },
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.createdby = userdetail[0].email
    this.userhubid = userdetail[0].HubId[0]
    this.checkVerificationPalletizationEnabled()
  },
  methods: {
    checkVerificationPalletizationEnabled() {
      this.isLoading = true; this.verificationHubName = '';
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + 'checkVerificationPalletizationEnabled?hubId='+this.userhubid,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.isLoading = false;
          if (result.data.ResultCode == 100) {
            this.isverificationenabled=result.data.ResponseData[0].isverificationenabled

            this.verificationHubName = result.data.verificationHubName;

            if(this.isverificationenabled == false){
              this.isverificationenabledMsg='For this Hub verification Hub is ' + this.verificationHubName + '.';
            }
          } else {
            this.isverificationenabledMsg='For this Hub AWB verification is not enabled.';
          }
        }, error => {
          this.isLoading = false;
        })
    },
    jsonToCSV(filename, data, csvfield, dateFilder = [], skipFilter = []) {
      var csvData = ''
      //Header
      if (this.title != null) {
        csvData += this.parseExtraData(this.title, '${data}\r\n')
      }
      //Fields
      for (let key in data[0]) {
        if (skipFilter.indexOf(key) == -1)
          csvData += csvfield[key] + ','
      }
      csvData = csvData.slice(0, csvData.length - 1)
      csvData += '\r\n'
      //Data
      data.map(function(item) {
        for (let key in item) {
          if (skipFilter.indexOf(key) == -1) {
            var escapedCSV = item[key] + '' // cast Numbers to string
            if (escapedCSV.match(/[,"\n]/)) {
              escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"'
            }
            if (escapedCSV == 'null')
              csvData += ',';
            else {
              if (dateFilder.indexOf(key) != -1)
                csvData += moment(escapedCSV).format('DD-MM-YYYY HH:mm:ss') + ','
              else
                csvData += escapedCSV + ','
            }
          }
        }
        csvData = csvData.slice(0, csvData.length - 1)
        csvData += '\r\n'
      })
      //Footer
      if (this.footer != null) {
        csvData += this.parseExtraData(this.footer, '${data}\r\n')
      }
      filename += moment().format('DD-MM-YYYY') + '.XLSX';
      return this.export(csvData, filename, "application/csv");
      return csvData
    },
    export (data, filename, mime) {
      let blob = this.base64ToBlob(data, mime)
      download(blob, filename, mime)
      this.$alertify.success("Successful")
    },
    base64ToBlob(data, mime) {
      let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
      let bstr = atob(base64)
      let n = bstr.length
      let u8arr = new Uint8ClampedArray(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], {
        type: mime
      })
    },
    getCSVFile(){
      this.csvData=[]
      this.ScannedMPSList.map(item=>{
        this.csvData.push({
          ParentAWBNo: this.AWB,
          AWBStatus:this.AWBStatus,
          MPSID: item.MPSID,
          IsMeasurementFlag: item.IsMeasurementFlag,
          CurrentHubId: item.CurrentHubId,
          PhysicalWeight: item.PhysicalWeight,
          Length: item.Dimensions.Length,
          Width: item.Dimensions.Width,
          Height: item.Dimensions.Height,
          Unit: item.Dimensions.Unit,
          CFT: item.CFT,
          MPSStatus: item.MPSStatus,
          VolumetricWeight: item.VolumetricWeight,
          MeasurementMethod: item.MeasurementMethod,
          MeasurementDateandTime: item.MeasurementDateandTime,
          MeasurementLocation: item.MeasurementLocation,
          MeasurementDoneBy: item.MeasurementDoneBy
        })

      })
      this.csvFields = {
        'ParentAWBNo': 'ParentAWBNo',
        'AWBStatus':'AWBStatus',
        'MPSID': 'MPSID',
        'IsMeasurementFlag': 'IsMeasurementFlag',
        'CurrentHubId': 'CurrentHubId',
        'PhysicalWeight': 'PhysicalWeight',
        'Length': 'Length',
        'Width': 'Width',
        'Height': 'Height',
        'Unit': 'Unit',
        'CFT': 'CFT',
        'MPSStatus': 'MPSStatus',
        'VolumetricWeight': 'VolumetricWeight',
        'MeasurementMethod': 'MeasurementMethod',
        'MeasurementDateandTime': 'MeasurementDateandTime',
        'MeasurementLocation': 'MeasurementLocation',
        'MeasurementDoneBy': 'MeasurementDoneBy'
      }
      this.jsonToCSV('ParentMPSDetails_', this.csvData, this.csvFields);
    },
    getAWBList() {
      if(this.AWBnumber!=''){
        this.resetFlt()
        this.emptyValueMsg = true;
        this.isLoadingSearch = true;
        this.ScannedMPSList = []
        this.ScannedMPSListFLT=[]
        this.AWB = ''
        this.AWBStatus = ''
        this.input = ({});
        axios({
            method: 'GET',
            'url': apiUrl.api_url_hubops + 'getAwbDetails?awbNo=' + this.AWBnumber + '&currentHubId=' + this.userhubid,
            'data': this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
            }
          })
          .then(result => {
            this.isLoadingSearch = false;
            if (result.data.ResultCode == 100) {
              if(result.data.ResponseData.ClientID && result.data.ResponseData.TruckloadType && result.data.ResponseData.RouteMode &&
                result.data.ResponseData.BookingType && result.data.ResponseData.ClientBusinessAccountId){
                this.emptyValueMsg = false;
              }

              this.ScannedMPSList = result.data.ResponseData.MPS;
              this.ClientID = result.data.ResponseData.ClientID
              this.TruckloadType = result.data.ResponseData.TruckloadType
              this.RouteMode = result.data.ResponseData.RouteMode
              this.BookingType = result.data.ResponseData.BookingType
              this.ClientBusinessAccountId = result.data.ResponseData.ClientBusinessAccountId
              this.clientcontractid=result.data.ResponseData.ClientContractID
              this.$alertify.success(result.data.ReturnMessage)
              this.noRecord=false
              this.showAll=true
              window.scrollTo(0, 6000);
              this.AWB = result.data.ResponseData.ParentAWBNo
              this.AWBStatus = result.data.AWBStatus
              var IsMeasurementFlag = this.ScannedMPSList.filter(obj=>{
                return obj.IsMeasurementFlag == true
              })
              this.MPSMeasuredCount = IsMeasurementFlag.length
            } else {
              this.noRecord=true
              this.ScannedMPSList = []
              this.AWB = ''
              this.AWBStatus = ''
              this.MPSMeasuredCount = 0
              this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            this.isLoadingSearch = false;
            console.error(error)
          })
      }
    },
    addAWBDetails() {
      this.isLoading = true;
      this.input = ({
        "awbNo": this.AWBnumber,
        "measurementMethod": this.measurementmethod,
        "mps": this.MPSnumber,
        "dimentionUOM": this.dimensionUOM,
        "length": this.length,
        "breadth": this.breadth,
        "height": this.height,
        "weight": this.weight,
        "measurementLocation": this.userhubid,
        "measurementDoneBy": this.createdby,
        "clientId" : this.ClientID,
        "truckloadType" : this.TruckloadType,
        "routeMode" : this.RouteMode,
        "bookingType" : this.BookingType,
        "clientBusinessAccountId":this.ClientBusinessAccountId,
        "clientcontractid":this.clientcontractid
      })
      // console.log(this.input);
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'storeMPSMeasurementDetails',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.isLoading = false;
          if (result.data.ResultCode == 100) {
            this.$alertify.success(result.data.ReturnMessage);
            this.getAWBList();
            this.resetForm();
          } else {
            this.$alertify.error(result.data.ReturnMessage);
          }
        }, error => {
          this.isLoading = false;
          console.error(error)
        })
    },
    getRowData(data) {
      this.$refs.mps.focus()
      this.MPSnumber = data.MPSID
      if(data.MeasurementMethod){
        this.measurementmethod = data.MeasurementMethod
      }
      // this.dimensionUOM = data.Dimensions.Unit
      this.length = data.Dimensions.Length
      this.breadth = data.Dimensions.Width
      this.height = data.Dimensions.Height
      this.weight = data.PhysicalWeight
      this.CFT = data.CFT
    },
    onSubmitDimension: function(dimension) {
      this.$validator.validateAll('dimension').then((result) => {
        if (!result) {
          this.type = 'isSubmit'
          return false;
        } else {          
          if(this.emptyValueMsg){
            this.$alertify.error('Values is not received against the given AWB no.'); return false;
          }else{
            this.type = ''
            this.addAWBDetails();
          }
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    resetForm() {
      this.isLoading = false
      this.type = ''
      this.measurementmethod = 'Manual'
      this.MPSnumber = ''
      this.dimensionUOM = 'Centimeter'
      // this.length = ''
      // this.breadth = ''
      // this.height = ''
      // this.weight = ''
      this.CFT = ''
      this.ClientID = ''
      this.TruckloadType = ''
      this.RouteMode = ''
      this.BookingType = ''
      this.ClientBusinessAccountId = ''
      this.emptyValueMsg = true;
      // this.ScannedMPSList = []
      // this.AWB = ''
      // this.MPSMeasuredCount = 0
      this.$validator.reset()
    },
    resetAWBData() {
      this.showAll=false
      this.noRecord=true
      this.AWBnumber = ''
      this.AWBStatus = ''
      this.AWB = ''
      this.MPSMeasuredCount = 0
      this.ScannedMPSList = []
      this.$validator.reset()
    },
    getAWBData(){
      this.errorMessage=''
      if(!this.FltMPSnumber && this.FltIsMeasurement==false){
        this.errorMessage='Select Any One Criteria'
        return false
      }
      this.showAll=false
      this.noRecord=false
      if(this.AWBnumber!=''){
        if(this.FltMPSnumber){
          this.ScannedMPSListFLT = this.ScannedMPSList.filter(obj=>{
            return obj.MPSID.toLowerCase() == this.FltMPSnumber.toLowerCase()
          })
          if((this.ScannedMPSList.length==0 || (this.ScannedMPSList.length>0 && this.FltMPSnumber!='') ) && this.ScannedMPSListFLT.length == 0){
            this.noRecord=true;
            this.showAll=false
          }
        }
        else {
          if(this.FltIsMeasurement==true){
            this.ScannedMPSListFLT = this.ScannedMPSList.filter(obj=>{
              return obj.IsMeasurementFlag == null
            })
          }else{
            // this.noRecord=false;
            this.showAll=true
          }
          if((this.ScannedMPSList.length==0 || (this.ScannedMPSList.length>0 && this.FltIsMeasurement) ) && this.ScannedMPSListFLT.length == 0){
            this.noRecord=true;
            this.showAll=false
          }
        }
      }else{
        this.noRecord=true;
      }
    },
    validateCheckField(){
      this.errorMessage=''
      if(this.FltMPSnumber){
        this.FltIsMeasurement=false
        this.disableField = true
        this.$alertify.error("Reset Field to continue search")
        // this.errorMessage='Select Any One Criteria'
      }else if(this.FltIsMeasurement==false){
        this.disableMPSField=false
      }else{
        this.disableMPSField=true
      }
    },
    validateMPSField(){
      this.errorMessage=''
      this.disableField = false
      if(this.FltIsMeasurement==true){
        this.disableMPSField=true
      }
    },
    resetFlt() {
      this.errorMessage=''
      this.FltMPSnumber = ''
      this.FltIsMeasurement = false
      if(this.ScannedMPSList.length>0){
        this.showAll=true
        this.noRecord=false
      }else{
        this.showAll=false
        this.noRecord=true
      }
      this.disableField=false
      this.disableMPSField=false
      this.ScannedMPSListFLT=[]
      this.isLoadingSearch = false
      this.$validator.reset()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/AWBVerification/AWBVerification.js